export const environment = {
  production: false,
  appName: 'Iveco Backoffice Tools',
  apiUrl: '/api',
  keycloak: {
    enabled: true
  },
  authEndpoints: {
    login: '/auth/login',
    keycloakLogin: '/auth/login/keycloak',
    register: '/auth/register',
    refresh: '/auth/refresh',
    logout: '/auth/logout'
  },
  storage: {
    tokenKey: 'access_token',
    refreshTokenKey: 'refresh_token',
    userKey: 'current_user'
  }
};
